module.exports = __webpack_public_path__ + "static/media/20_B.afe5dbe7.png";